import { Box, Text } from '@redbubble/design-system';
import styles from './Bubble.module.scss';

interface BubbleProps {
  title: string;
  onClick?: (
    clickEvent: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  href?: string;
  element?: string;
}

export const Bubble: React.FC<BubbleProps> = ({
  title,
  onClick,
  href,
  element,
}) => {
  return (
    <Box
      className={styles.bubble}
      onClick={onClick}
      data-testid="bubble-box"
      role="link"
      element={element}
      href={href}
    >
      <Text type="display5">{title}</Text>
    </Box>
  );
};
